import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { ItemIcon } from "../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";
import { RightArrow } from "../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";

const SalesModeSignIn = () => {
    return (
        <SalesModeSignInWrap to="/sales-mode-login">
            <div className="sales-mode__inner-wrap">
                <IconWrap>
                    <ItemIcon width="20px" height="20px" color="#ffffff" />
                </IconWrap>
                <div>
                    <h4>Sales Mode</h4>
                    <p>Sign in to access your inventory and orders</p>
                </div>
            </div>
            <div>
                <RightArrow />
            </div>
        </SalesModeSignInWrap>
    );
};

const SalesModeSignInWrap = styled(Link)`
    border-radius: 5px;
    border: 1px solid rgba(219, 220, 224, 0.5);
    background: #f9f9f9;
    box-shadow: 15px 30px 40px 0px rgba(0, 0, 0, 0.07);
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin-top: 40px;
    .sales-mode__inner-wrap {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    h4 {
        font-weight: 900;
        font-size: 0.9375rem;
        line-height: 20px;
        color: #000000;
    }
    p {
        font-weight: 400;
        font-size: 0.625rem;
        line-height: 13px;
        color: #979797;
    }

    @media (max-width: 520px) {
        padding: 15px;
        height: auto;
        min-height: 60px;
        .small-link-card__card-text {
            margin-left: 12px;
        }
    }
    @media (max-width: 414px) {
        padding: 12px 13px;
        height: 60px;
    }
`;

const IconWrap = styled.div`
    border-radius: 4.741px;
    background: var(--colours-kBLU-500, #1dcbef);
    box-shadow: 0px 0px 11.852px 0px rgba(0, 0, 0, 0.06);
    padding: 6px;
`;
export default SalesModeSignIn;
